import type { DocumentStructureSortBy } from "@msuite/utils/documents";
import { SortingIndicator } from "../../table/data-table/head/sorting-indicator";
import type { ChildrenProps, ClassNameProps } from "../../types";
import { cn } from "../../utils";
import { useFileExplorerContext } from "./context";

/** Props Interface */
interface FileExplorerHeaderItemProps extends ClassNameProps, ChildrenProps {
	onClick?: () => void;
	name?: DocumentStructureSortBy;
}

export function FileExplorerHeaderItem({
	className,
	children,
	onClick,
	name,
}: FileExplorerHeaderItemProps) {
	/** Context */
	const { sortBy } = useFileExplorerContext();

	/** Render */
	return (
		<div
			className={cn("cursor-pointer h-stack active:opacity-70", className)}
			onClick={onClick}
		>
			{sortBy === name && (
				<div className="-my-3 -mx-2">
					<SortingIndicator
						columnId={name ?? ""}
						onClick={() => {}}
					/>
				</div>
			)}
			<p>{children}</p>
		</div>
	);
}
